// libs
import { createContext, useContext } from 'react';

interface INudgeContext {
  showNudge: (sessionTime: number, source: string, variant: string) => void;
  hideNudge: () => void;
  nudgeSource: string;
  trackListingLoad: () => void;
  trackFilterApplied: (count: number) => void;
  trackPDPView: () => void;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

const initialValue: INudgeContext = {
  showNudge: EMPTY_FUNC,
  hideNudge: EMPTY_FUNC,
  nudgeSource: '',
  trackListingLoad: EMPTY_FUNC,
  trackFilterApplied: EMPTY_FUNC,
  trackPDPView: EMPTY_FUNC,
};

const NudgeContext = createContext(initialValue);

export const useLoginNudgeContext = () => useContext(NudgeContext);

export default NudgeContext;
